import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  header: {
    marginTop: theme.spacing(3),
  },
}));



// WEBPACK FOOTER //
// ./src/components/QuizPage/components/BuyerRegistration/useStyles.js